export const commonsamples_Serbian = [
    {
        id:0,
        chatname:"Check Grammar",
        promptsandresponses:[
            {
             id:1,
             prompt:"Ja sam bicu tu.",
             response:"Ja cu biti tu."
            },
        ]
    },
    {
        id:1,
        chatname:"Extract Keywords",
        promptsandresponses:[
            {
             id:1,
             prompt:"Električni automobili su već neko vreme prisutni, ali tek u poslednjih nekoliko godina postali su popularniji. Sa sve većom zabrinutošću za životnu sredinu i globalno zagrevanje, mnogi ljudi sada razmatraju električne automobile kao alternativu tradicionalnim automobilima na benzin. Jedna od glavnih prednosti električnih automobila je to što ne proizvode emisije. To znači da ne emituju štetne gasove u atmosferu, što je dobra vest za našu planetu. Takođe, mnogo su tiši od tradicionalnih automobila, što ih čini odličnim izborom za vožnju po gradu.",

             response:"Električni automobili, životna sredina, globalno zagrevanje, alternativa, automobili na benzin, nula emisija, štetni gasovi, atmosfera, planeta, tiši, vožnja po gradu."
            },
        ]
    },
    {
        id:2,
        chatname:"Summary",
        promptsandresponses:[
            {
            id:1,
            prompt:"Električni automobili su već neko vreme prisutni, ali tek u poslednjim godinama su postali popularniji. Sa sve većom zabrinutošću za životnu sredinu i globalno zagrevanje, mnogi ljudi sada razmatraju električne automobile kao alternativu tradicionalnim automobilima na benzin. Jedna od glavnih prednosti električnih automobila je to što ne proizvode emisije. To znači da ne emituju štetne gasove u atmosferu, što je dobra vest za našu planetu. Pored toga, oni su mnogo tiši od tradicionalnih automobila, što ih čini odličnim izborom za vožnju po gradu.",

            response:"Električni automobili postaju popularni zbog sve veće brige za životnu sredinu i globalno zagrevanje. Oni ne proizvode emisije i mnogo su tiši od tradicionalnih automobila, što ih čini odličnom opcijom za vožnju po gradu."
            },
        ]
    },
    {
        id:3,
        chatname:"Compact",
        promptsandresponses:[
            {
             id:1,
             prompt:"Električni automobili su već neko vreme prisutni, ali tek u poslednjim godinama postaju sve popularniji. S obzirom na rastuću zabrinutost za životnu sredinu i globalno zagrevanje, mnogi ljudi sada razmatraju električne automobile kao alternativu tradicionalnim automobilima na benzin. Jedna od glavnih prednosti električnih automobila je to što ne proizvode emisije. To znači da ne emituju štetne gasove u atmosferu, što je dobra vest za našu planetu. Pored toga, mnogo su tiši od tradicionalnih automobila, što ih čini odličnim izborom za vožnju u gradu.",

             response:"Električni automobili postaju sve popularniji zbog brige o životnoj sredini. Ne proizvode emisije, što ih čini odličnim izborom za vožnju u gradu."
            },
        ]
    },
    {
        id:4,
        chatname:"Description",
        promptsandresponses:[
            {
             id:1,
             prompt:"Kožna torba, smeđa, ispod 29 dolara",

             response:`Kožna torba je stilski i funkcionalni dodatak koji je savršen za svaku priliku. Napravljena od visokokvalitetne smeđe kože, ova torba je izdržljiva i dizajnirana da traje. Ima prostranu glavnu pregradu u koju možete staviti sve svoje potrepštine, uključujući telefon, novčanik, ključeve i još mnogo toga. Torba ima jednostavan, ali elegantan dizajn, sa jednom ručkom za nošenje preko ramena koja olakšava nošenje. Laka je i udobna, a podesiva ručka omogućava savršeno pristajanje svakom tipu tela.
             Najbolje od svega, ova kožna torba je dostupna za manje od 29 dolara, što je pristupačna opcija za svakoga ko želi kvalitetnu torbu bez da razbije banku. Bez obzira da li obavljate obaveze, idete na posao ili izlazite, ova kožna torba je savršen dodatak koji će upotpuniti vaš izgled.`
            },
        ]
    },
    {
        id:5,
        chatname:"Email",
        promptsandresponses:[
            {
             id:1,
             prompt:"Roditeljski sastanak, 12:30 sreda, Pošiljalac: Tom",

             response:"Naslov: Podsetnik - Roditeljski sastanak, 12:30 sreda\n\nDragi roditelji,\n\nNadam se da ste dobro. Samo kratki podsetnik da imamo roditeljski sastanak zakazan za 12:30 popodne u sredu. Ovaj sastanak je odlična prilika da razgovaramo o napretku vašeg deteta u školi i da se bavimo svim briga ili pitanjima koja imate.\nKao što svi znate, sastanak će se održati online ove godine, i dobićete link za pridruživanje sastanku putem e-pošte. Molimo vas da proverite svoju e-poštu pre početka sastanka. Ako imate tehničkih problema, slobodno me kontaktirajte i rado ću vam pomoći. Radujem se susretu sa vama svima i razgovoru o napretku vašeg deteta u školi. Imamo mnogo toga o čemu treba da razgovaramo, pa vas molim da se pripremite sa bilo kakvim pitanjima ili briga koje možda imate.\n\nHvala vam i vidimo se u sredu.\n\nS poštovanjem,\n\nTom"
            },
        ]
    },
    {
        id:6,
        chatname:"Story",
        promptsandresponses:[
            {
             id:1,
             prompt:"ptica, pas, sunčan dan",

             response:"Jednog sunčanog dana, ptica je sedela na grani drveta i pevala melodioznu pesmu. Ptica je uživala u toplom suncu i svežem vazduhu. Odjednom, pas je dotrčao do drveta, lajući glasno. Ptica se uplašila i odletela, ali pas je nastavio da je juri.\nPtica je letela što je brže mogla, ali pas je bio brz i odlučan. Dok je potera trajala, ptica je primetila da pas ne pokušava da joj naudi, već da se igra sa njom. Ptica je sletela na obližnju granu, još uvek uplašena, ali radoznala. Pas je pokušao da se popne na drvo, ali bilo je previsoko za njega.\nPtica je shvatila da pas nije pretnja i odlučila se da se igra sa njim. Počela je da cvrkuće i leta oko njega, pozivajući ga da se igra. Pas je bio oduševljen i veselo je mašao repom. Dvoje su počeli da se jure oko drveta, uživajući u životu.\nKako je dan prolazio, sunce je počelo da zalazi i ptica je znala da je vreme da ode. Pozdravila je psa cvrkutom i odletela. Pas ju je posmatrao kako nestaje u horizontu, osećajući malo tugu, ali i srećan zbog zabave koju su podelili.\nOd tog dana, pas bi često dolazio do drveta, nadajući se da će ponovo videti pticu. Iako se više nisu igrali zajedno, sećanje na taj sunčani dan ostalo je zauvek u srcu psa. To je podsetnik na radost koja dolazi iz neočekivanih prijateljstava i lepote prirode na sunčan dan."
            },
        ]
    },
    {
        id:7,
        chatname:"Improve",
        promptsandresponses:[
            {
             "id":1,
             "prompt":"Električni automobili postaju popularni zbog rastuće zabrinutosti za životnu sredinu i globalno zagrevanje. Oni ne proizvode emisije i mnogo su tiši od tradicionalnih automobila, što ih čini odličnim izborom za vožnju po gradu.",

             "response":"Električna vozila postaju sve popularnija zbog rastuće zabrinutosti za životnu sredinu i globalno zagrevanje. Ova vozila ne proizvode emisije i rade tiše od tradicionalnih automobila, što ih čini idealnim izborom za vožnju po gradu."
            },
        ]
    }

    

]
